export const CLIENT_FORECAST_BALANCE_BY_MONTH_VALUE_TYPE = {
  VALUE: 'value',
  COUNT: 'count',
} as const;

export type CLIENT_FORECAST_BALANCE_BY_MONTH_VALUE_TYPE = typeof CLIENT_FORECAST_BALANCE_BY_MONTH_VALUE_TYPE;
export type A_CLIENT_FORECAST_BALANCE_BY_MONTH_VALUE_TYPE = CLIENT_FORECAST_BALANCE_BY_MONTH_VALUE_TYPE[keyof CLIENT_FORECAST_BALANCE_BY_MONTH_VALUE_TYPE];
